import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import logo from '../assets/GMF logo no background.png';
import '../Styles/CreateInstitutionAccount.css';

function CreateInstitutionAccount() {
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    const [error, setError] = useState('');
    const [emailExists, setEmailExists] = useState(false);

    const navigate = useNavigate();
    const url = process.env.REACT_APP_API_URL;

    // Handle form submission
    const handleSubmit = async (e) => {
        e.preventDefault();
        setError('');
        setEmailExists(false);

        // Validate passwords
        if (password !== confirmPassword) {
            setError('Passwords do not match.');
            return;
        }

        // Check password strength
        const passwordValid = validatePassword(password);
        if (!passwordValid) {
            setError(
                'Password must be at least 10 characters long, contain at least one number and one special character.'
            );
            return;
        }

        // Check if email exists
        const emailAlreadyExists = await checkEmailExists(email);
        if (emailAlreadyExists) {
            setEmailExists(true);
            return;
        }

        // Proceed to create account
        const success = await createAccount(email, password);
        if (success) {
            navigate('/gmfhome');
        } else {
            setError(
                'An error occurred while creating the account. Please try again.'
            );
        }
    };

    // Validate password
    const validatePassword = (password) => {
        const minLength = /.{10,}/;
        const hasNumber = /[0-9]/;
        const hasSpecialChar = /[!@#$%^&*(),.?":{}|<>]/;

        return (
            minLength.test(password) &&
            hasNumber.test(password) &&
            hasSpecialChar.test(password)
        );
    };

    // Check if the email already exists in the db
    const checkEmailExists = async (email) => {
        try {
            const response = await fetch(`${url}/check-email`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ email }),
            });

            if (!response.ok) {
                throw new Error('Failed to check email.');
            }

            const data = await response.json();
            return data.exists; // Assuming the API returns { exists: true/false }
        } catch (error) {
            console.error('Error checking email:', error);
            setError('Unable to verify email at this time.');
            return false;
        }
    };

    // Function to create account on the backend
    // TODO: Connect to endpoint on the backend
    const createAccount = async (email, password) => {
        try {
            const response = await fetch(
                `${url}/create-institution-account`,
                {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({ email, password }),
                }
            );

            if (!response.ok) {
                throw new Error('Failed to create account.');
            }

            return true;
        } catch (error) {
            console.error('Error creating account:', error);
            return false;
        }
    };

    // content
    return (
        <div className="root-container">
            <div className="logo-container">
                <img className="logo" src={logo} alt="MD-Sensei Logo"></img>
            </div>

            <div className="create-account-box">
                <h2>Create Institution Account</h2>
                <form onSubmit={handleSubmit}>
                    <div className="form-group">
                        <label>Email:</label>
                        <input
                            type="email"
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                            required
                        />
                        {emailExists && (
                            <p style={{ color: 'red' }}>
                                An account with this email already exists.
                            </p>
                        )}
                    </div>
                    <div className="form-group">
                        <label>Password:</label>
                        <input
                            type="password"
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                            required
                        />
                    </div>
                    <div className="form-group">
                        <label>Confirm Password:</label>
                        <input
                            type="password"
                            value={confirmPassword}
                            onChange={(e) => setConfirmPassword(e.target.value)}
                            required
                        />
                    </div>
                    {error && <p style={{ color: 'red' }}>{error}</p>}
                    <button type="submit">Create Account</button>
                </form>
            </div>
        </div>
    );
}

export default CreateInstitutionAccount;
